<template>
  <div class="charts" id="bar">

  </div>

</template>

<script>
  import { queryMonthOrderTotal } from  "@/api/order/orderinfo"
  export default {
    name: "charts",
    props: {
      title: {
        type: String,
        default: () => (
          ''
        )
      },
    },
    data() {
      return {

      }
    },
    created() {
      queryMonthOrderTotal().then(res => {
        if(res.data.code==0){
          this.$nextTick(() => {
            this.drawBar(res.data.data);
          })
        }
      })
    },
    methods: {
      drawBar(data) {
        let myChart = this.$echarts.init(document.getElementById("bar"));
        const option =  {
          color: ['#3FA7DC','#44D38A'],
          title: { text: '' },
          legend: {
            data: ['预约', '代叫']
          },
          tooltip: {},
          /*xAxis: {
            data: ["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"]
          },*/
          dataset: {
            source: data
          },
          xAxis: {type: 'category'},
          yAxis: {},
          /*series: [{
            name: '订单数量',
            type: 'bar',
            data: [5, 20, 36, 10, 10, 20,5, 20, 36, 10, 10, 20]
          }]*/
          series: [
            {type: 'bar'},
            {type: 'bar'}
          ]
        }
        myChart.setOption(option);
      }
    }
  };
</script>

<style scoped>
  .charts {
    background: #fff;
    width: 100%;
    height: 400px;
    box-shadow: 0px 2px 4px 0px rgba(187, 187, 187, 0.25);
    border-radius: 4px;
  }
</style>
